import { render, staticRenderFns } from "./StatisticsPage.vue?vue&type=template&id=b40f44be&scoped=true&"
import script from "./StatisticsPage.vue?vue&type=script&lang=js&"
export * from "./StatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40f44be",
  null
  
)

export default component.exports